import { Typography } from '@arionbanki/arionui';
import { Links } from 'components';
import type { FinishPageProps } from './useFinish';

export function FinishSecondary({ keys, links, t }: FinishPageProps) {
	return false === keys.isPrimary ? (
		<>
			<div className="col-12 col-md-6">
				<Typography className="mb-4" TagName="h4">
					<span className="text-brown">{t(keys.leftTitle, 'finish')}</span>
				</Typography>
				<Typography TagName="p">{t(keys.leftText, 'finish')}</Typography>
				<Links className="text-secondary" links={links[0]} />
			</div>
			<div className="col-12 col-md-6">
				<Typography className="mb-4" TagName="h4">
					<span className="text-brown">{t(keys.rightTitle, 'finish')}</span>
				</Typography>
				<Typography TagName="p">{t(keys.rightText, 'finish')}</Typography>
				<Links className="text-secondary" links={links[1]} />
			</div>
		</>
	) : null;
}
